"use strict";

var __assign = void 0 && (void 0).__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __createBinding = void 0 && (void 0).__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function get() {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = void 0 && (void 0).__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = void 0 && (void 0).__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
var __rest = void 0 && (void 0).__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
var __importDefault = void 0 && (void 0).__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
var react_1 = __importStar(require("react"));
var classnames_1 = __importDefault(require("classnames"));
var spaui_utils_1 = require("@tencent/spaui-utils");
var info_1 = __importDefault(require("./info"));
var Metas = function Metas(props, ref) {
  var _a, _b;
  var children = props.children,
    // className,
    id = props.id,
    style = props.style,
    _c = props.show,
    show = _c === void 0 ? true : _c,
    paddingY = props.paddingY,
    paddingX = props.paddingX,
    _d = props.classNameMap,
    classNameMap = _d === void 0 ? {} : _d,
    column = props.column,
    asSub = props.asSub,
    asInfo = props.asInfo,
    legacy = props.legacy,
    labelPaddingLeft = props.labelPaddingLeft,
    labelPaddingY = props.labelPaddingY,
    labelWidth = props.labelWidth,
    labelWidthAuto = props.labelWidthAuto,
    innerAlignItems = props.innerAlignItems,
    formGroupWidth = props.formGroupWidth,
    gap = props.gap,
    theme = props.theme,
    restProps = __rest(props, ["children", "id", "style", "show", "paddingY", "paddingX", "classNameMap", "column", "asSub", "asInfo", "legacy", "labelPaddingLeft", "labelPaddingY", "labelWidth", "labelWidthAuto", "innerAlignItems", "formGroupWidth", "gap", "theme"]);
  var pY = typeof paddingY === 'number' ? "".concat(paddingY, "px") : paddingY;
  var pX = typeof paddingX === 'number' ? "".concat(paddingX, "px") : paddingX;
  var gapX = typeof gap === 'number' ? "".concat(gap, "px") : gap;
  var formGroupWidthX = typeof formGroupWidth === 'number' ? "".concat(formGroupWidth, "px") : formGroupWidth;
  var cssText = __assign((_a = {}, _a['--metas-py'] = pY, _a['--metas-px'] = pX, _a['--meta-gap-top'] = gapX, _a['--meta-inner-align'] = innerAlignItems, _a['--meta-name-py'] = typeof labelPaddingY === 'number' ? "".concat(labelPaddingY, "px") : labelPaddingY, _a['--meta-name-pl'] = typeof labelPaddingLeft === 'number' ? "".concat(labelPaddingLeft, "px") : labelPaddingLeft, _a['--meta-name-width'] = labelWidthAuto ? 'auto' : (0, spaui_utils_1.pxVal)(labelWidth), _a['--meta-form-group-width'] = formGroupWidthX, _a), style);
  return show ? react_1["default"].createElement("div", __assign({}, restProps, (0, spaui_utils_1.globalProps)(props, {
    className: (0, classnames_1["default"])(classNameMap.Metas || 'metas', (_b = {
      'column-metas': column,
      'sub-metas': asSub,
      'info-metas': asInfo,
      'meta-legacy': legacy
    }, _b["metas-".concat(theme)] = theme, _b)),
    supportAllEvents: true,
    ref: ref
  }, Metas), {
    style: (0, spaui_utils_1.removeUndefined)(cssText)
  }), children) : null;
};
(0, spaui_utils_1.setComponentMark)(Metas, info_1["default"]);
exports["default"] = (0, react_1.memo)((0, react_1.forwardRef)(Metas));